import { FormattedMessage } from "react-intl";
import { Grid as MuiGrid, Stack as MuiStack } from "@mui/material";

import { formatItemHtmlList } from "@framework/exchange";
import { ModuleType, type IToken, type IBalance } from "@framework/types";
import { Card, List, Typography } from "@dzambalaorg/ui-kit";

import { Erc721TransferButton } from "../../buttons";

export interface ICommonTokenPanelProps {
  token: IToken;
}

export const CommonTokenPanel = (props: ICommonTokenPanelProps) => {
  const { token } = props;

  const { price } =
    token.template?.contract?.contractModule === ModuleType.LOTTERY ||
    token.template?.contract?.contractModule === ModuleType.RAFFLE
      ? // @ts-ignore
        token.round
      : token.template;

  return (
    <Card sx={{ height: "fit-content", justifyContent: "flex-start" }}>
      <Card.Content>
        <MuiStack>
          <Typography variant="h5" component="p" mb={0.5}>
            <FormattedMessage id="pages.token.priceTitle" />
          </Typography>
          <List>{formatItemHtmlList(price)}</List>
        </MuiStack>
        {token.balance && (
          <MuiStack mt={2}>
            <Typography variant="h5" component="p" mb={0.5}>
              <FormattedMessage id="pages.token.balanceTitle" />
            </Typography>
            <List>
              {token.balance.map((balance: IBalance, index: number) => (
                <List.ItemText key={index}>{balance.amount}</List.ItemText>
              ))}
            </List>
          </MuiStack>
        )}
      </Card.Content>

      <Card.Footer>
        <MuiGrid container alignItems="center" spacing={1}>
          <MuiGrid size={{ xs: 12 }}>
            <Erc721TransferButton token={token} />
          </MuiGrid>
        </MuiGrid>
      </Card.Footer>
    </Card>
  );
};
